import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/multi-level-menu-test-3-1',
            name: 'admin-multi-level-menu-test-3-1',
            component: () => import(/* webpackChunkName: "page-admin-default-multi-level-menu-test-3-1" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "3.1"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "三级菜单示例"
                            },
                            {
                                name: "3.1"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
